<template>
    <div
        :class="[
            {'is-empty': '' === searchPhrase},
            'search-form'
        ]"
    >
        <input
            v-model="searchPhrase"
            class="search-phrase is-small"
            type="text"
            :placeholder="placeholder"
            @input="$emit( 'input', searchPhrase )"
        >
        <button
            v-if="'' !== searchPhrase"
            class="clear-button"
            @click="clearSearch"
        >
            <i class="fal fa-times-circle" />
        </button>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: '',
        },
    },

    data: () => ({
        searchPhrase: '',
    }),

    methods: {
        /**
         * Clears search input
         *
         */
        clearSearch() {
            this.searchPhrase = '';
            this.$emit('input', this.searchPhrase);
        },
    },
};
</script>
